import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="fertilizer-route"
        path="/fertilizer/:id?"
        component={Page} />
];

export default Routes;